import React, { useEffect, useState } from 'react';
import { NavHeader } from '../PageElements/NavHeader';
import Header from '../PageElements/Header';
import Footer from '../PageElements/Footer';
import '../CSS/CareerOpportunities.css';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import ScrollReset from '../Tools/ScrollReseter';
import { Link } from 'react-router';

export default function CareerOpportunities() {
  const [jobs, setJobs] = useState([]);
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  
  useEffect(() => {
    FetchData();

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const FetchData = () => {
    fetch(process.env.PUBLIC_URL + '/jobs_manifest.json')
      .then((res) => {
        res.json().then((manifest) => {
          Promise.allSettled(
            manifest.map((path) => {
              return fetch(process.env.PUBLIC_URL + path).then((res) => res.text());
            })
          ).then((jobs) => {
            const parsedJobs = [];
            for (const job of jobs) {
              parsedJobs.push(job.value);
            }

            setJobs(parsedJobs);
          });
        }).catch((err) => {
          console.log('Issue setting the data from the manifest', res, err);
        });
      })
      .catch((err) => {
        console.log('Issue grabbing and setting the job manifest', process.env.PUBLIC_URL + '/jobs_manifest.json', err);
      });
  };

  return (
    <>
      <ScrollReset />
      <div className='wrapper'>
        <NavHeader maxScroll={200} windowWidth={windowWidth} />
        <Header
          imageURL={'Images/Career.jpg'}
          title={'Career Opportunities'}
          opacity={0.04}
          stretchHeight='null'
          yOffset={-400}
          titleSize={windowWidth > 750 ? 48 : 22}
          windowWidth={windowWidth}
        />
        <Content jobs={jobs} windowWidth={windowWidth} />
        <Footer imageURL={'Images/Career.jpg'} windowWidth={windowWidth} />
      </div>
    </>
  );
}

function Content({ jobs, windowWidth }) {
  return (
    <>
      <div className='content' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {jobs.length > 0 ? (
          <JobCards jobs={jobs} windowWidth={windowWidth} />
        ) : (
          <>
            <div className='noListings'>No available listings at this time.</div>
          </>
        )}
      </div>
    </>
  );
}

function JobCards({ jobs, windowWidth }) {
  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '15px', width: '100%' }}>
        {jobs.map((job, index) => (
          <JobCard job={job} key={index} windowWidth={windowWidth} />
        ))}
      </div>
    </>
  );
}

function JobCard({ job, windowWidth }) {
  const [open, setOpen] = useState(false);
  const parsedJob = MarkdownParser(job);

  return (
    <>
      <div className='card'>
        <div className='cardHeader'>
          <div className='cardTitle'>
            <p style={{ fontFamily: 'Jura', fontWeight: 'bold', fontSize: '24px', color: 'var(--Complementary)' }}>{parsedJob.title}</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              {windowWidth > 750 && (
                <svg width='7' height='10' viewBox='0 0 7 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M3.5 0C1.42893 -1.19209e-07 0.5 1.19915 0.5 3.16667C0.5 5.7 3.5 9.5 3.5 9.5C3.5 9.5 6.5 5.7 6.5 3.16667C6.5 1.19915 5.57107 2.38419e-07 3.5 0ZM3.5 4.5C4.32843 4.5 5 3.82843 5 3C5 2.17157 4.32843 1.5 3.5 1.5C2.67157 1.5 2 2.17157 2 3C2 3.82843 2.67157 4.5 3.5 4.5Z'
                    fill='black'
                  />
                </svg>
              )}

              <p style={{ fontFamily: 'Jura', color: 'rgba(0, 0, 0, 0.50)' }}>{parsedJob.location}</p>
            </div>
          </div>

          <p style={{ color: 'rgba(0, 0, 0, 0.50)', fontFamily: 'Jura', fontSize: '12px' }}>{parsedJob.postedDate}</p>
        </div>

        <div className='cardDesc'>{parsedJob.positionOverview}</div>

        {windowWidth > 750 ? (
          <>
            <div className='cardFooter'>
              <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                {parsedJob?.jobTags.map((tag, index) => (
                  <>
                    <div key={index} className='cardTag'>
                      {tag}
                    </div>
                  </>
                ))}
              </div>

              <div onClick={() => setOpen(true)} className='cardActionButton'>
                More Info
              </div>
            </div>
          </>
        ) : (
          <>
            <div className='cardFooter'>
              <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                {parsedJob?.jobTags.map((tag, index) => (
                  <>
                    <div key={index} className='cardTag'>
                      {tag}
                    </div>
                  </>
                ))}
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'start', width: '100%', paddingLeft: '24px' }}>
              <div onClick={() => setOpen(true)} className='cardActionButton'>
                More Info
              </div>
            </div>
          </>
        )}
      </div>

      <Dialog
        slotProps={{
          paper: {
            style: {
              maxHeight: '98%',
              width: '100vw',
              overflowY: 'auto',
              border: 2,
              borderColor: '#5472b8',
              borderRadius: 10,
              margin: '10px',
              maxWidth: '100%',
            },
          },
        }}
        fullWidth
        maxWidth={false}
        open={open}
        onClose={() => setOpen(false)}>
        <DialogTitle style={{ color: '#bc9c4e' }}>{job.jobTitle}</DialogTitle>

        <div onClick={() => setOpen(false)} className='modalButton' style={{ position: 'absolute' }}>
          <img style={{ cursor: 'pointer' }} alt='close' src='Icons/Close.svg' height={20} width={20} />
        </div>

        <DialogContent>
          <MoreInfo job={job} />
        </DialogContent>
      </Dialog>
    </>
  );
}

function MoreInfo({ job }) {
  return (
    <>
      <div className='moreInfo' style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(marked.parse(job)) }}></div>
        <Link className='cardActionButton' to={'/contact'} state={{ topic: 'CareerOpportunities' }}>
          Contact
        </Link>
      </div>
    </>
  );
}

/**
 * A custom parser for jobs
 * @param {String} job
 * @returns An object of the job with the title, position overview, location, posted date, and job tags
 */
function MarkdownParser(job) {
  const tokens = marked.lexer(job);
  const parsedData = {
    title: '',
    positionOverview: '',
    location: '',
    postedDate: '',
    jobTags: [],
  };
  let currentSection = '';

  tokens.forEach((token) => {
    if (token.type === 'heading') {
      if (token.depth === 1) {
        parsedData.title = token.text;
      } else if (token.depth === 2) {
        currentSection = token.text.toLowerCase();
      }
    } else if (token.type === 'paragraph') {
      const lines = token.text.split('\n');
      lines.forEach((line) => {
        if (line.includes('Posting Date')) parsedData.postedDate = line.replace(/\*\*/g, '').split(' ')[2];
        if (line.includes('Job Tags')) parsedData.jobTags = line.replace(/\*\*/g, '').split(':')[1].split(',');
      });

      switch (true) {
        case currentSection.includes('position overview'):
          parsedData.positionOverview = token.text;
          break;
        case currentSection.includes('location'):
          parsedData.location = token.text;
          break;
        case currentSection.includes('posting date'):
          parsedData.postedDate = token.text;
          break;
        default:
          break;
      }
    }
  });

  return parsedData;
}
